export default __webpack_public_path__ + "static/media/bata-mujer.6574899e.png";